import { FOLD_ICON_TYPE } from '@framework/workbench/ui/fold/config';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';
import { LOCK_KEY } from '@src/slide/domain/ui-model/element-modeles/property/lock/lock.interface';
import { EFFECT_KEY } from '@src/slide/domain/ui-model/element-modeles/property/effect/effect.interface';
import { BORDER_KEY } from '@src/slide/domain/ui-model/element-modeles/property/border/border.interface';
import { FILL_KEY } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';
import {
    SUBSCRIPT_KEY,
    SUPERSCRIPT_KEY,
    FONT_EFFECT_KEY,
    FONT_FILL_KEY,
    FONT_BORDER_KEY,
} from '@src/slide/domain/ui-model/element-modeles/property/text/constants';

export const ChildActionType = {
    ALIGN: 'adjustAlign',
    HORIZONTALLT_LEFT: 'horizontally-left',
    HORIZONTALLT_CENTER: 'horizontally-center',
    HORIZONTALLT_RIGHT: 'horizontally-right',
    VERTICALLY_TOP: 'vertaically-top',
    VERTICALLY_CENTER: 'vertaically-center',
    VERTICALLY_BOTTOM: 'vertaically-bottom',
    DISTRIBUTE_HORIZONTALLT: 'distribute-horizontally',
    DISTRIBUTE_VERTICALLY: 'distribute-vertically',
};
// ID枚举集合
export const ActionType = {
    DIVIDER: 'divider-menu-item', // 分割线ID

    // 顶部菜单-------------------------------
    // 文件菜单项id
    NEW: 'new-menu-item',
    ONLINE_DOC: 'online-doc-sub',
    ONLINE_SHEET: 'online-sheet-sub',
    ONLINE_DEMO: 'online-demo-sub',
    ONLINE_COLLECT: 'online-collect-sub',
    OTHER_DOC: 'other-doc-sub',
    ONLINE_MIND: 'online-mind-menu-item',
    ONLINE_FLOWCHART: 'online-flowchart-menu-item',
    ONLINE_TEMPLATE: 'online-template-menu-item',
    IMPORT_MENU: 'import-doc-menu-item-wrapper',
    IMPORT_DOC: 'import-doc-menu-item',
    NEW_FILE: 'new-file-sub',
    SAVE_TEMP: 'save-temp-menu-item',
    EXPORT: 'export-menu-item',
    NATIVE_PPT: 'native-ppt-sub',
    EXPORT_PDF: 'export-pdf',
    EXPORT_IMAGE: 'export-image',
    GENERATE_COPIES: 'generate-copies-menu-item',
    GENERATE_SHORTCUT: 'generate-shortcut-menu-item',
    REVISION_RECORD: 'revision-record-menu-item',
    HISTORY_VERSION: 'history-version-menu-item',
    SAVE_REVISION: 'save-revision-menu-item',
    ADD_REVISION: 'add-revision-menu-item',
    EXIT_HISTORY: 'exit-history-menu-item',
    BROWSE_RECORD: 'browse-record-menu-item',
    PERMISSION_MENU: 'permission-menu-sub',
    PERMISSION_SETTING: 'permission-setting-menu-item',
    ADVANCED_PERMISSION: 'advanced-permission-menu-item',
    EXIT_DOCUMENT: 'exit-document-menu-item',
    SET_WATER_MARK: 'set-water-mark-menu-item',
    TRANSFER_OWNERSHIP: 'transfer-ownership-menu-item',
    RENAME: 'rename-menu-item',
    PRINT: 'print-menu-item',
    HELP_FEEDBACK: 'help-feedback-sub',
    REPORT: 'report-menu-item',
    APPEAL: 'appeal-menu-item',
    HELP: 'help-menu-item',
    ABOUT: 'about-menu-item',
    SHORTCUT_KEY: 'shortcut-key-menu-tem',
    COMMUNITY_CONVENTION: 'community-convention',
    ACCUSATION: 'accusation-menu-item',
    PRIVACY: 'privacy-menu-item',
    PRIVACY_POLICY: 'privacy-policy-menu-item',
    THIRD_PARTY_DATA_SHARING: 'third-party-data-sharing-menu-item',
    THIRD_AUTHORIZATION_MANAGEMENT: 'third-authorization-management',
    PERSONAL_INFO_COLLECTION: 'personal-info-collection-menu-item',
    INFRINGEMENT: 'infringement-menu-item',
    DEVELOPMENT: 'development-menu-item',
    PERFORMANCE: 'performance-menu-item',
    ACCESSIBILITY: 'accessibility-switch',
    SWITCH_CERTIFICATION: 'switch-certification',
    COPY_DOC_LINK: 'copy-doc-link-menu-item',
    SYNC_TO_LIST: 'sync-to-list',
    NOT_SYNC: 'not-sync',
    SYNC_CURRENT_FILE: 'sync-current-file',
    SYNC_ALL_FILE: 'sync-all-file',
    SYNC_DESC: 'sync-description',
    PDF_TRANSFORM: 'pdf-transform', // pdf转换转换
    PDF_TO_PPT: 'pdf-to-ppt',
    PDF_TO_WORD: 'pdf-to-word',
    PDF_TO_EXCEL: 'pdf-to-excel',
    FILE_COMPRESSION: 'file-compression',   // 文件瘦身
    AI_GENERATE_PAGE: 'ai-generate-page', // ai 生成页
    AI_GENERATE_PAGE_MOBILE: 'ai-generate-page-mobile', // ai 生成页

    /* ⬇️ 企业微信专属 ⬇️ */
    FORWARD_DOC_IN_MEETING: 'forward-doc-in-meeting', // 融合会议内转发文档
    ADD_TO_FAST_ACCESS: 'add-to-fast-access-menu-item',
    ADD_TO_COLLECTION: 'add-to-collection-menu-item',
    ADD_TO_WEDRIVE: 'add-to-wedrive-menu-item',
    VIEW_IN_WEDRIVE: 'view-in-wedrive-sub',
    OPEN_WEDRIVE_TITLE: 'open-wedrive-title-menu-item',
    OPEN_WEDRIVE: 'open-wedrive-menu-item',
    ADD_TO_WEDRIVE_ANOTHER: 'add-to-wedrive-another-menu-item',
    COPY_SHARE_LINK: 'copy-share-link-menu-item',
    TRANSFER_OWNERSHIP_WEWORK: 'advanced-permission-menu-item-wework',
    HELP_CENTER: 'helpCenter',
    HOT_KEY: 'hot-key',
    COMPLAIN: 'complain',
    DELETE_FIlE: 'delete-file',
    /* ⬆️ 企业微信专属 ⬆️ */

    // 编辑菜单项id
    UNDO: 'revoke-menu-item',
    REDO: 'redo-menu-item',
    CUT: 'cut-menu-item',
    COPY: 'copy-menu-item',
    PASTE: 'paste-menu-item',
    DELETE: 'delete-menu-item',
    SELECT_ALL: 'select-all-menu-item',
    ALIGN: ChildActionType.ALIGN,
    ALIGN_HORIZONTALLT_LEFT: `plugin|${ChildActionType.ALIGN}|${ChildActionType.HORIZONTALLT_LEFT}`,
    ALIGN_HORIZONTALLT_CENTER: `plugin|${ChildActionType.ALIGN}|${ChildActionType.HORIZONTALLT_CENTER}`,
    ALIGN_HORIZONTALLT_RIGHT: `plugin|${ChildActionType.ALIGN}|${ChildActionType.HORIZONTALLT_RIGHT}`,
    ALIGN_VERTICALLY_TOP: `plugin|${ChildActionType.ALIGN}|${ChildActionType.VERTICALLY_TOP}`,
    ALIGN_VERTICALLY_CENTER: `plugin|${ChildActionType.ALIGN}|${ChildActionType.VERTICALLY_CENTER}`,
    ALIGN_VERTICALLY_BOTTOM: `plugin|${ChildActionType.ALIGN}|${ChildActionType.VERTICALLY_BOTTOM}`,
    ALIGN_DISTRIBUTE_HORIZONTALLT: `plugin|${ChildActionType.ALIGN}|${ChildActionType.DISTRIBUTE_HORIZONTALLT}`,
    ALIGN_DISTRIBUTE_VERTICALLY: `plugin|${ChildActionType.ALIGN}|${ChildActionType.DISTRIBUTE_VERTICALLY}`,
    REPLACE: 'replace-menu-item',
    MOBILE_TEXT_COPY: 'mobile-text-copy-menu-item',
    MOBILE_SELECT_ALL: 'mobile-select-all-menu-item',
    MOBILE_EDIT: 'mobile-edit',
    MOBILE_ROTATE: 'mobile-rotate',
    MOBILE_OCR: 'mobile-ocr',

    // 插入菜单项id
    INSERT_TEXT: 'text-menu-item',
    INSERT_PICTURE: 'pic-menu-item',
    AI_PICTURE: 'pic-ai',
    AI_REPLACE_SLIDE: 'ai-replace-slide',
    REPLACE_PICTURE: 'pic-replace-menu-item',
    REPLACE_PICTURE_FROM_FILE: 'pic-replace-from-file',
    REPLACE_PICTURE_FROM_CLIPBOARD: 'pic-replace-from-clipboard',
    REPLACE_PICTURE_SEARCH: 'pic-replace-search',
    REPLACE_PICTURE_GENERATE: 'pic-replace-generate',
    INSERT_FORM: 'table-menu-item',
    SELECT_TABLE: 'select-table-sub',
    INSERT_SHAPE: 'shape-menu-item',
    INSERT_SHAPE_PARENT: 'shape-menu-item-parent',
    INSERT_ALL: 'insert-menu-item',
    SELECT_SHAPE: 'select-shape-sub',
    LINK: 'link-menu-item',
    EDIT_LINK: 'edit_link-menu-item',
    REMOVE_LINK: 'remove_link-menu-item',
    OPEN_LINK: 'open_link-menu-item',
    INSERT_WITH_LINK: 'insert-item-with-link',
    INSERT_WITH_LATEX: 'insert-item-with-latex', // 插入Latex公式
    REPLACE_WITH_LATEX: 'replace-item-with-latex', // 编辑/替换Latex公式
    OCR_WITH_LATEX: 'ocr-item-with-latex', // 识别公式
    INSERT_CHART: 'chart-menu-item',
    NEW_SLIDE: 'new-slide-menu-item',
    INSERT_ANIMATION: 'anim-menu-item',
    SLIDE_CODE: 'slide-code-menu-item',
    INSERT_IFRAME: 'insert-iframe',
    INSERT_IFRAME_ITEM: 'insert-iframe-item',
    INSERT_TENCENT_DOC_ID: 'insert_tencent_doc',
    UPLOAD_LOCAL_FILE: 'upload_local_file',
    ADDON_UNOFFICIAL: 'addon-unofficial', // 插入非官方插件
    EXTERNAL_ADDONS_PANEL_TITLE: 'external-addons-panel-title', // 第三方插件 文案
    ADDON_MALL_SETTING: 'addon-mall-setting', // 管理插件
    ADDON_MALL_SHOP: 'addon-mall-shop', // 获取更多
    INSERT_SLIDE_FOOTER: 'insert-slide-footer', // 插入页脚
    INSERT_BLANK_SLIDE: 'insert-blank-slide', // 插入空白页面
    INSERT_TEMPLATE_SLIDE: 'insert-template-slide', // 插入空白页面
    INSERT_AUDIO: 'insert-audio-menu-item', // 插入音频,
    INSERT_VIDEO: 'insert-video-menu-item', // 插入视频

    /* ⬇️ 企业微信专属 ⬇️ */
    INSERT_FILE: 'insert-file',
    INSERT_FILE_IN_WEIXIN: 'insert-file-in-weixin',
    INSERT_LOCAL_FILE: 'insert-local-file',
    INSERT_DOC_IN_WEIXIN: 'insert-doc-in-weixin',
    /* ⬆️ 企业微信专属 ⬆️ */

    // 格式菜单项id
    FORMAT_BRUSH: 'format-brush-menu-item',
    CLEAR_FORMAT: 'clear-format-menu-item',
    RANK: 'rank-menu-item',
    TEXT_STYLE: 'text-style-menu-item',
    TEXT_SPACE: 'text-space-sub',
    TEXT_SPACE_VERY_TIGHT: 'text-space-very-tight-item',
    TEXT_SPACE_TIGHT: 'text-space-tight-item',
    TEXT_SPACE_COMMON: 'text-space-common-item',
    TEXT_SPACE_LOOSE: 'text-space-loose-item',
    TEXT_SPACE_VERY_LOOSE: 'text-space-very-loose-item',
    TEXT_COLOR: 'text-color-sub',
    TEXT_COLOR_PALETTE: 'text_color_palette',
    TEXT_BG: 'text-bg-color-sub',
    TEXT_BG_PALETTE: 'text_bg_palette',
    TYPESET: 'typeset-menu-item',
    // JUSTIFIED: 'justified-sub',
    // ALIGN: 'align-sub',
    ROW_SPACE: 'row-space-sub',
    ROW_SPACE_ABSOLUTE: 'row-space-absolute',
    COLUMNS: 'columns',
    COLUMN_NUMBER: 'columnNumber',
    COLUMN_SPACE: 'columnSpace',
    LINE_HEIGHT_IS: 'line-height-is',
    // ROW_SPACE_VERY_TIGHT: 'row-space-very-tight-item',
    // ROW_SPACE_TIGHT: 'row-space-tight-item',
    // ROW_SPACE_COMMON: 'row-space-common-item',
    // ROW_SPACE_LOOSE: 'row-space-loose-item',
    // ROW_SPACE_VERY_LOOSE: 'row-space-very-loose-item',
    MARGIN_LEFT: 'margin-left',
    SPACE_BEFORE: 'para-padding-top',
    SPACE_AFTER: 'para-padding-bottom',
    INDENT: 'indent-sub',
    TEXT_INDENT: 'text-indent',
    TAB_LIST: 'tab-list',
    TAB_SIZE: 'tab-size',
    PARAGRAPH_MORE: 'paragraph-more-sub',
    UPDATE_PARAGRAPH_PROPS: 'update-paragraph-props',
    PADDING_ADJUST: 'padding-adjust',
    SYMBOL_NUMBER: 'symbol-number-menu-item',
    SYMBOL_SUB: 'symbol-sub',
    NUMBER_SUB: 'number-sub',
    TASK_LIST: 'task-list-sub',
    TABLE_DETAIL: 'table-detail-menu-item',
    INSERT_ROW_COL: 'insert-row-colo',
    DELETE_ROW_COL: 'delete-row-colo',
    INSERT_ROW_TOP: 'insert-row-top-sub',
    INSERT_ROW_BOTTOM: 'insert-row-bottom-sub',
    DELETE_ROW: 'delete-row-sub',
    INSERT_COL_LEFT: 'insert-col-left-sub',
    INSERT_COL_RIGHT: 'insert-col-right-sub',
    DELETE_COL: 'delete-col-sub',
    BORDER_LINE: 'border-line-sub',
    COLOR_FILL: 'color-fill-sub',
    MERGE_CELL: 'merge-cell-sub',
    HORIZONTAL_ALIGN: 'horizontal-align-sub',
    VERTICAL_ALIGN: 'vertical-align-sub',
    CLEAR_FORMAT_SUB: 'clear-format-sub',
    AVERAGE_ROW: 'average-row-sub',
    AVERAGE_COL: 'average-col-sub',
    FORMAT_PIC: 'format-pic-menu-item',
    RESET_PIC: 'reset-pic-sub',
    BORDER_LINE_ITEM: 'border-line-menu-item',
    NONE_FILL: 'none-fill',
    TRANSPARENCY: 'transparency',
    // FILL_COLOR:'fill-color',  //用下面定义的
    NONE_BORDER: 'none-border',
    BORDER_LINE_COLOR: 'border-line-color',
    BORDER_LINE_WIDTH: 'border-line-width',
    BORDER_LINE_STYLE: 'border-line-style',
    BORDER_ARROW_STYLE: 'border-arrow-style',
    BORDER_GRADUAL_LINE: 'border-gradual-line',
    EDIT_TEXT: 'edit-text',

    // 幻灯片菜单项
    CREATE_SLIDE: 'create-slide-menu-item',
    DELETE_SLIDE: 'delete-slide-menu-item',
    COPY_SLIDE: 'copy-slide-menu-item',
    MOVE_SLIDE: 'move-slide-menu-item',
    MOVE_SLIDE_UP: 'move-slide-up-sub',
    MOVE_SLIDE_DOWN: 'move-slide-down-sub',
    MOVE_SLIDE_TOP: 'move-slide-top-sub',
    MOVE_SLIDE_BOTTOM: 'move-slide-bottom-sub',
    SLIDE_SIZE: 'slide-size-menu-item',
    SLIDE_SIZE_TOOLBAR: 'slide-size-toolbar',
    SLIDE_STANDARD: 'slide-standard-sub',
    SLIDE_WIDE: 'slide-wide-sub',
    SLIDE_CUSTOM: 'slide-custom-sub',
    SLIDE_HEADER_FOOTER: 'slide-header-footer-sub',
    CHANGE_BG: 'change-bg-menu-item',
    CHANGE_BG_TOOLBAR: 'change-bg-toolbar',
    MASTER_LAYOUT: 'master-layout-menu-item',
    MASTER_LAYOUT_TOOLBAR: 'master-layout-toolbar',
    BG_COLOR_FILL: 'bg-color-fill-sub',
    BG_IMG_FILL: 'bg-img-fill-sub',
    BG_GRADUAL_FILL: 'bg-gradual-fill-sub',
    USE_LAYOUT: 'use-layout-menu-item',
    USE_TITLE: 'use-title-sub',
    USE_ONLY_TITLE: 'use-only-title-sub',
    USE_TITLE_CONTENT: 'use-title-content-sub',
    USE_BLANK: 'use-blank-sub',
    USE_SECTION_TITLE: 'use-section-title-sub',
    USE_TWO_CONTENT: 'use-two-content-sub',
    USE_COMPARE: 'use-compare-sub',
    USE_CONTENT_TITLE: 'use-content-title-sub',
    USE_PIC_TITLE: 'use-pic-title-sub',
    USE_TITLE_VERTICAL_TEXT: 'use-title-vertical-text-sub',
    USE_VERTICAL_TITLE_TEXT: 'use-vertical-title-text-sub',
    TRANSITION: 'transition-menu-item',
    TRANSITION_TYPE: 'transition-type-sub',
    TRANSITION_USE_ALL: 'transition-use-all-sub',
    EDIT_MASTER: 'edit-master-menu-item',
    TEMP_LIB: 'temp-lib-menu-item',
    CHANGE_THEME_BG: 'change-theme-bg-menu-item',
    RESTART_DEMO: 'restart-demo-menu-item',
    CUR_PAGE_DEMO: 'cur-page-demo-menu-item',
    WATERMARK: 'slide-set-water-mark',
    IMPORT_SLIDE: 'import-slide',
    IMPORT_LOCAL_SLIDE: 'import-local-slide',
    IMPORT_ONLINE_SLIDE: 'import-online-slide',

    // 视图菜单项
    VIEW_NORMAL: 'view-normal-menu-item',
    SLIDE_BROWSE: 'slide-browse-menu-item',
    SHOW_RATIO: 'show-ratio-menu-item',
    GUIDE_LINE: 'guide-line-menu-item',
    ALIGN_LINE: 'align-line-menu-item',
    SHOW_RULE: 'show-rule-menu-item',
    SHOW_SPEAKER_REMARK: 'show-speaker-remark-menu-item',
    FULL_SCREEN_MODEL: 'full-screen-model',

    // 智能工具菜单项
    INTELLIGENT_CORRECTION: 'intelligent-correction-menu-item',
    INTELLIGENT_TRANSLATION: 'intelligent-translation-menu-item',
    INTELLIGENT_TYPESET: 'intelligent-typeset-menu-item',
    LITTLE_TOOLS: 'little-tools-item',
    PIC_RESOLUTION: 'pic-resolution-sub',
    REMOVE_WATERMARK: 'remove-watermark-sub',

    // 右键菜单-------------------------------
    // 空白处右键显示菜单
    HIDE_SLIDE: 'hide-slide-menu-item',
    CANCEL_HIDE_SLIDE: 'cancel-hide-slide-menu-item',
    REFERENCE_LINE: 'reference-line-menu-item',
    SET_BG_FORMAT: 'set-bg-format-menu-item',
    SLIDE_PLAY: 'slide-play-menu-item',
    DISPLAY_TEXT_RULER: 'display-text-ruler',
    GRID_AND_GUIDES: 'grid-and-guides',
    ADD_HORZ_GUIDE: 'add-horz-guide',
    ADD_VERT_GUIDE: 'add-vert-guide',
    DISPLAY_GUIDES: 'display-guides',
    DISPLAY_GRID_LINE: 'display-grid-line',
    GRID_LINE_ALIGN: 'grid-line-align',
    GRID_DIALOG: 'grid-dialog',
    TOGGLE_SNAP_LINE: 'toggle-snap-line',

    // 主题
    THEME_EDIT: 'theme-edit',
    THEME_DELETE: 'theme-delete',

    // 参考线右键菜单
    SET_GUIDE_COLOR: 'set-guide-color',
    GUIDE_COLOR_PANEL: 'set-guide-panel',
    DELETE_GUIDE: 'delete-guide',

    // 右键菜单通用操作
    ROOT_UPPER: 'root-upper-menu-item',
    MOVE_ITEM_UP: 'move-menu-item-up',
    BASE_DOWN: 'base-down-menu-item',
    MOVE_ITEM_DOWN: 'move-menu-item-down',
    SELECT_WINDOW: 'select-window',

    // 右键菜单选中文本框操作
    EDIT_TOP_POINT: 'edit-top-point-menu-item',
    ENTER_EDITOR: 'enter-editor-menu-item',
    SHAPE_FORMAT: 'shape-format-menu-item',

    // 右键菜单选中图片操作
    TAILOR_PIC: 'tailor-pic',
    TAILOR_PIC_NORMAL: 'tailor-pic-normal',
    TAILOR_PIC_SHAPE: 'tailor-pic-shape',
    TAILOR_PIC_SELECT_SHAPE: 'tailor-pic-select-shape',
    TAILOR_PIC_WH: 'tailor-pic-wh',
    PIC_FORMAT: 'pic_format',
    MULTI_TAILOR_PIC: 'multi-tailor-pic',
    TO_SOURCE_URL: 'to-source-url',

    TAILOR_PIC_WH_1_1: 'tailor-pic-1-1',
    TAILOR_PIC_WH_2_3: 'tailor-pic-2-3',
    TAILOR_PIC_WH_3_4: 'tailor-pic-3-4',
    TAILOR_PIC_WH_3_5: 'tailor-pic-3-5',
    TAILOR_PIC_WH_4_5: 'tailor-pic-4-5',
    TAILOR_PIC_WH_3_2: 'tailor-pic-3-2',
    TAILOR_PIC_WH_4_3: 'tailor-pic-4-3',
    TAILOR_PIC_WH_5_3: 'tailor-pic-5-3',
    TAILOR_PIC_WH_5_4: 'tailor-pic-5-4',
    TAILOR_PIC_WH_16_9: 'tailor-pic-16-9',
    TAILOR_PIC_WH_16_10: 'tailor-pic-16-10',

    SET_COVER: 'set-cover',
    FILE_COVER: 'file-cover',
    VIDEO_COVER: 'video-cover',
    RESET_COVER: 'reset-cover',

    // 右键菜单选中表格操作
    DELETE_TABLE: 'delete-table-menu-item',

    // 右键菜单选中文字框操作
    INSERT_LINK: 'insert-link-menu-item',

    // 多选菜单
    EDIT_FORMAT: 'edit-format-menu-item',
    GROUP: 'group-menu-item',
    MOVE_ITEM: 'move-item',

    // 工具栏-------------------------------
    ADD_SLIDE: 'add-slide',
    EVOKE_KEYBOARD: 'evoke-keyboard',
    PACKUP_KEYBOARD: 'packup-keyboard',
    NOTE: 'note',
    LAYOUT_SUGGESTION: 'layout_suggestion',
    TEXT_EDIT_PANEL: 'text-edit-panel',
    ADD_EDIT_PANEL: 'add-edit-panel',
    // 加号面板专有
    INSERT_PHOTO_PICTURE: 'photo-picture',
    INSERT_SHOOT: 'shoot-picture',
    // 图片
    CLIP: 'clip',
    ROTATE: 'rotate',
    REMAKE: 'remake',
    RESET_PICTURE: 'reset-picture',
    RESET_PICTURE_SELF: 'reset-picture-self',
    RESET_PICTURE_SIZE: 'reset-picture-size',
    PICTURE_COLOR: 'picture-color',
    REGULATE: 'regulate',

    // 未选中
    // BACKGROUND: 'background',
    TYPESETTING: 'typesetting',
    TEMPLATE: 'template',
    PAGE_SETTING: 'pagesetting',
    // 快捷美化
    // 一开始叫快捷工具，但是产品改名了，但是上报的数据又没改，所以这里的英文仍然叫quickTool
    QUICK_TOOL: 'quickTool',
    FONT_HANDLER: 'font-handler',
    PIC_HANDLER: 'pic-handler',
    COLOR_HANDLER: 'color-handler',

    CHANGE_THEME: 'changeTheme',
    UNIFORM_FONT: 'uniformFont',
    REPLACE_FONT: 'replaceFont',
    MUTI_PICTURE_SIZE_SETTING: 'mutiPictureSizeSetting',
    MUTI_PICTURE_POS_SETTING: 'mutiPicturePosSetting',
    MUTI_PICTURE_EXPORT: 'mutiPictureExport',

    DIGITAL_CONTENT_DESENSITIZATION: 'digitalContentDesensitization',

    OPEN_UNIFORM_FONT: 'openuniformFont',
    OPEN_REPLACE_FONT: 'openreplaceFont',
    OPEN_MUTI_PICTURE_SIZE_SETTING: 'openmutiPictureSizeSetting',
    OPEN_MUTI_PICTURE_POS_SETTING: 'openmutiPicturePosSetting',
    OPEN_MUTI_PICTURE_EXPORT: 'openmutiPictureExport',
    OPEN_IMAGES_JOINT: 'openImagesJoint',


    OPEN_TEXT_DESENSITIZATION: 'opentextDesensitization',
    VIP_LINK_TEXT: 'viplinktext',
    /** 智能工具 */
    INTELLIGENT_TOOL: 'intelligent-tool',
    // 文本
    FONT: 'font',
    // 主题字体
    FONT_THEME: 'font-theme',
    FONTSIZE: 'fontSize',
    FONTSIZE_INCREASE: 'font_size_increase', // 字体递增递减
    BOLD: 'bold',
    ITALIC: 'italic',
    UNDERLINE: 'underLine',
    DELETELINE: 'deleteLine',
    SUBSCRIPT: SUBSCRIPT_KEY,
    SUPERSCRIPT: SUPERSCRIPT_KEY,
    FORECOLOR: 'foreColor',
    BACKCOLOR: 'backColor',

    // 项目符号
    ITEMNUMBER: 'itemNumber',
    DIGITNUMBER: 'digitNumber',
    BULLET_COLOR: 'bulletColor',
    BULLET_SIZE: 'bulletSize',
    BULLET_START_NUMBER: 'bulletStartNumber',
    BULLET_CUSTOM_TEXT: 'bulletCustomText',
    BULLET_CUSTOM_IMAGE: 'bulletCustomImage',
    BULLET_SET: 'bulletSet',

    BORDERCOLOR: BORDER_KEY,
    FILLCOLOR: FILL_KEY,
    FILLCOLOR_PALETTE: 'fillcolor_palette',
    BORDERCOLOR_PALETTE: 'border_palette',
    PICK_COLOR: 'pick_color',
    FONTSIZE_UP: 'plugin|adjustFontSize|up',
    FONTSIZE_DOWN: 'plugin|adjustFontSize|down',
    TEXT_ADJUST: 'text-adjust',
    TEXT_FORMAT: 'text-format',

    // 效果：阴影、发光、映像、柔化边缘
    EFFECT: EFFECT_KEY,
    SHADOW: 'shadow',
    REFLECTION: 'reflection',
    GLOW: 'glow',
    SOFTEDGE: 'softEdge',

    // 多选
    ADDGROUP: 'addGroup',
    REMOVEGROUP: 'removeGroup',
    MOVEUP: 'moveUp',
    MOVETOP: 'moveTop',
    MOVEDOWN: 'moveDown',
    MOVEBOTTOM: 'moveBottom',
    // 通用
    QUICKSTYLE: 'quick-style',
    BORDERSTYLE: 'border-style',
    FORMAT: 'format',
    SEARCH: 'search',
    MORE: 'more',
    SIZE_ADJUST: LOCK_KEY,
    MORE_SETTING: 'more-setting',

    SEARCH_REPLACE: 'search-replace',

    TABLE_TAB: 'table-tab',

    OCR_PICTURE: 'ocr-pic-menu-item',
    DOWNLOAD_PICTURE: 'download-pic-menu-item',
    DOWNLOAD_ATTACHMENT: 'download-attachment', // 下载附件
    SWITCH_ATTACHMENT_SHOWTYPE: 'switch-attachment-showtype', // 切换附件显示模式
    DELETE_ATTACHMENT: 'delete-attachment', // 删除附件
    VIEW_ATTACHMENT: 'view-attachment', // 查看附件
    MORE_FONT: 'more-font',
    SIZE_WITH_RATIO: 'size_with_ratio',


    // 对齐
    HORIZONTAL_LEFT: 'horizontal_left',
    HORIZONTAL_CENTER: 'horizontal_center',
    HORIZONTAL_RIGHT: 'horizontal_right',
    HORIZONTAL_JUSTIFY: 'horizontal_justify',
    HORIZONTAL_DISTRIBUTE: 'horizontal_distribute',

    // 切换
    TOOLBAR_MODE: 'toolbar-mode',

    // 收折
    PAINTING: wrapIdForBig(FOLD_ICON_TYPE.PAINTING),
    FOLD_ICON_TYPE: wrapIdForBig(FOLD_ICON_TYPE.PARAGRAPH),
    FONT_SETTING: wrapIdForBig(FOLD_ICON_TYPE.FONT_SETTING),

    // 对外版本描述
    SLIDE_VERSION: 'slide_version',
    // 全局透明度
    OPACITY: 'opacity',
    ADDON: 'addon',
    NO_AVAILABLE_ADDON: 'noAvailableAddon',
    RECOMMEND_ADDON: 'recommendAddon',
    INSTALLED_ADDON: 'installedAddon',

    // 展示母版元素
    SHOW_MASTER_SHAPE: 'show-master-shape',
    // 占位符版式变更
    PLACEHOLDER_FORMAT: 'placeholder-format',

    // 节相关
    ADD_SECTION: 'add-section',
    RENAME_SECTION: 'rename-section',
    DELETE_SECTION: 'delete-section',
    DELETE_SECTION_AND_SLIDES: 'delete-section-and-slides',
    DELETE_ALL_SECTIONS: 'delete-all-sections',
    MOVE_SECTION_UP: 'move-section-up',
    MOVE_SECTION_DOWN: 'move-section-down',
    COLLAPSE_ALL_SECTIONS: 'collapse-all-sections',
    EXPAND_ALL_SECTIONS: 'expand-all-sections',

    // 文字填充
    FONT_FILL: FONT_FILL_KEY,

    // 文字边框
    FONT_BORDER: FONT_BORDER_KEY,

    // 主题色
    FONT_THEME_COLOR: 'font_theme_color', // 文本主题色
    FONT_BU_THEME_COLOR: 'font_bu_theme_color', // 项目符号主题色
    // FONT_BACK_THEME_COLOR: 'font_back_theme_color',
    FONT_FILL_COLOR: 'font_fill_color', // 形状填充主题色
    FONT_BORDER_COLOR: 'font_border_color', // 形状边框

    // 文字效果
    FONT_EFFECT: FONT_EFFECT_KEY,
    FONT_SHADOW: 'font-shadow',
    FONT_REFLECTION: 'font-reflection',
    FONT_GLOW: 'font-glow',

    // 文字方向
    TEXT_DIRECTION: 'text-direction',

    // 用model数据重刷文本
    FONT_REFRESH: 'font-refresh',

    // 图表快速工具栏
    EDIT_CHART_COMPONENT: 'editChartComponent',

    // 更改图表类型
    MODIFY_CHART_TYPE: 'modify-chart-type',

    MODIFY_CHART_TYPE_COLUMN: 'modify-chart-type-column',
    MODIFY_CHART_TYPE_TO_COLUMN_CLUSTERED: 'modify-chart-type-to-column-clustered',
    MODIFY_CHART_TYPE_TO_COLUMN_STACKED: 'modify-chart-type-to-column-stacked',
    MODIFY_CHART_TYPE_TO_COLUMN_PERCENT_STACKED: 'modify-chart-type-to-column-percent-stacked',

    MODIFY_CHART_TYPE_BAR: 'modify-chart-type-bar',
    MODIFY_CHART_TYPE_TO_BAR_CLUSTERED: 'modify-chart-type-to-bar-clustered',
    MODIFY_CHART_TYPE_TO_BAR_STACKED: 'modify-chart-type-to-bar-stacked',
    MODIFY_CHART_TYPE_TO_BAR_PERCENT_STACKED: 'modify-chart-type-to-bar-percent-stacked',

    MODIFY_CHART_TYPE_LINE: 'modify-chart-type-line',
    MODIFY_CHART_TYPE_TO_LINE_STANDARD: 'modify-chart-type-to-line-standard',
    MODIFY_CHART_TYPE_TO_LINE_STACKED: 'modify-chart-type-to-lint-stacked',
    MODIFY_CHART_TYPE_TO_LINE_PERCENT_STACKED: 'modify-chart-type-to-line-percent-stacked',
    MODIFY_CHART_TYPE_TO_LINE_STANDARD_WITH_POINT: 'modify-chart-type-to-line-standard-with-point',
    MODIFY_CHART_TYPE_TO_LINE_STACKED_WITH_POINT: 'modify-chart-type-to-line-stacked-with-point',
    MODIFY_CHART_TYPE_TO_LINE_PERCENT_STACKED_WITH_POINT: 'modify-chart-type-to-line-percent-stacked-with-point',

    MODIFY_CHART_TYPE_PIE: 'modify-chart-type-to-pietype', // 这个只是饼图/还原图的聚合菜单，取一个和饼图不一样的名字
    MODIFY_CHART_TYPE_TO_PIE: 'modify-chart-type-to-pie',
    MODIFY_CHART_TYPE_TO_OF_PIE: 'modify-chart-type-to-of-pie',
    MODIFY_CHART_TYPE_TO_OF_PIE_BAR: 'modify-chart-type-to-of-pie-bar',
    MODIFY_CHART_TYPE_TO_DOUGHNUT: 'modify-chart-type-to-doughnut',

    MODIFY_CHART_TYPE_AREA: 'modify-chart-type-to-area',
    MODIFY_CHART_TYPE_TO_AREA: 'modify-chart-type-to-area-standard',
    MODIFY_CHART_TYPE_TO_AREA_STACKED: 'modify-chart-type-to-area-stacked',
    MODIFY_CHART_TYPE_TO_AREA_PERCENT_STACKED: 'modify-chart-type-to-area-percent-stacked',

    MODIFY_CHART_TYPE_RADAR: 'modify-chart-type-to-radar',
    MODIFY_CHART_TYPE_TO_RADAR: 'modify-chart-type-to-radar-standard',
    MODIFY_CHART_TYPE_TO_RADAR_WITH_FILL: 'modify-chart-type-to-radar-with-fill',
    MODIFY_CHART_TYPE_TO_RADAR_WITH_POINT: 'modify-chart-type-to-radar-with-point',

    // 更改图表布局
    MODIFY_CHART_LAYOUT: 'modify-chart-layout',
    MODIFY_CHART_LAYOUT_CONTENT: 'modify-chart-layout-content',
    // 图表格式侧边栏
    CHART_FORMAT: 'chart-format',
    // 图表数据编辑
    EDIT_CHART_DATA: 'edit-chart-data',

    // 版式
    INSERT_LAYOUT: 'insert-layout',
    COPY_LAYOUT: 'copy-layout',
    DELETE_LAYOUT: 'delete-layout',

    // 占位符
    INSERT_PLACEHOLDER: 'insert-placeholder',
    INSERT_PLACEHOLDER_HORZ_CONTENT: 'insert-placeholder-horz-content',
    INSERT_PLACEHOLDER_VERT_CONTENT: 'insert-placeholder-vert-content',
    INSERT_PLACEHOLDER_HORZ_TEXT: 'insert-placeholder-horz-text',
    INSERT_PLACEHOLDER_VERT_TEXT: 'insert-placeholder-vert-text',
    INSERT_PLACEHOLDER_PICTURE: 'insert-placeholder-picture',
    INSERT_PLACEHOLDER_TABLE: 'insert-placeholder-table',

    // 演示
    LOCAL_PLAY_FROM_BEGIN: 'local-play-from-begin',
    LOCAL_PLAY_FROM_CURRENT: 'local-play-from-current',
    LOCAL_WITH_PRESENTER_VIEW: 'local-with-presenter-view',
    MOBILE_REMOTE_PLAY: 'mobile-remote-play',
    REMOTE_PLAY: 'remote-play',
    TENCENT_MEETING_PLAY: 'tencent-meeting-play',

    SINGLE_TOOLBAR_MENU: 'single-toolbar-menu',

    // 视图
    EDIT_VIEW: 'edit-view',
    MASTER_VIEW: 'master-view',
    ADJUST_SLIDE_50: 'adjust-slide-50',
    ADJUST_SLIDE_75: 'adjust-slide-75',
    ADJUST_SLIDE_100: 'adjust-slide-100',
    ADJUST_SLIDE_125: 'adjust-slide-125',
    ADJUST_SLIDE_150: 'adjust-slide-150',
    ADJUST_SLIDE_200: 'adjust-slide-200',
    ADJUST_SLIDE_300: 'adjust-slide-300',
    ADJUST_SLIDE_400: 'adjust-slide-400',
    AUTO_ADJUST_SLIDE: 'auto-adjust-slide',
    ADJUST_SLIDE: 'adjust-slide',
    NOTE_SWITCH: 'note-switch',

    // 美化tab
    CHANGE_TEMPLATE_CONTENT: 'change-template-content',
    CHANGE_TEMPLATE_MORE: 'change-template-more',
    CHANGE_THEME_COLOR_TOOLBAR: 'change-theme-color-toolbar',
    CHANGE_THEME_COLOR_TOOLBAR_MORE: 'change-theme-color-toolbar-more',
    CHANGE_THEME_COLOR_TOOLBAR_CUSTOM: 'change-theme-color-toolbar-custom',
    LAYOUT_SUGGESTION_TOOLBAR: 'layout-suggestion-toolbar',
    UNIFORM_FONT_TOOLBAR: 'uniform-font-toolbar',
    PIC_HANDLE_TOOLBAR: 'pic-handle-toolbar',

    // 切换tab
    TRANSITION_CHANGE: 'transition-change',
    TRANSITION_PREVIEW: 'transition-preview',
    TRANSITION_APPLY_ALL: 'transition-apply-all',
    TRANSITION_DURATION: 'transition-duration',
    TRANSITION_SOUND: 'transition-sound',
    TRANSITION_EFFECT_OPTION: 'transition-effect-option',
    TRANSITION_EFFECT_TOOLBAR: 'transition-effect-toolbar',

    // 简约切换菜单
    TRANSITION_CHANGE_SIMPLE: 'transition-change-simple',
    TRANSITION_EFFECT_SIMPLE_MENU: 'transition-effect-simple-menu',
    TRANSITION_SIMPLE_MENU_ITEM_CHANGE: 'transition-simple-menu-item-change',
    TRANSITION_SIMPLE_MENU_ITEM_EFFECT: 'transition-simple-menu-item-effect',
    TRANSITION_SIMPLE_MENU_ITEM_DURATION: 'transition-simple-menu-item-duration',
    TRANSITION_SIMPLE_MENU_ITEM_APPLY_ALL: 'transition-simple-menu-item-apply-all',
    TRANSITION_SIMPLE_MENU_ITEM_CHANGE_EMPTY: 'transition-simple-menu-item-change-empty',
    TRANSITION_SIMPLE_MENU_ITEM_CHANGE_FADE: 'transition-simple-menu-item-change-fade',
    TRANSITION_SIMPLE_MENU_ITEM_CHANGE_PUSH: 'transition-simple-menu-item-change-push',
    TRANSITION_SIMPLE_MENU_ITEM_CHANGE_SWITCH: 'transition-simple-menu-item-change-switchKeyword',
    TRANSITION_SIMPLE_MENU_ITEM_CHANGE_CUT: 'transition-simple-menu-item-change-cut',
    TRANSITION_SIMPLE_MENU_ITEM_CHANGE_PULL: 'transition-simple-menu-item-change-pull',
    TRANSITION_SIMPLE_MENU_ITEM_CHANGE_COVER: 'transition-simple-menu-item-change-cover',
    TRANSITION_SIMPLE_MENU_ITEM_CHANGE_WARP: 'transition-simple-menu-item-change-warp',
    TRANSITION_SIMPLE_MENU_ITEM_CHANGE_FLIP: 'transition-simple-menu-item-change-flip',
    TRANSITION_SIMPLE_MENU_ITEM_CHANGE_GALLERY: 'transition-simple-menu-item-change-gallery',
    TRANSITION_SIMPLE_MENU_ITEM_CHANGE_PRISM: 'transition-simple-menu-item-change-prism',
    TRANSITION_SIMPLE_MENU_ITEM_CHANGE_FLASH: 'transition-simple-menu-item-change-flash',

    TRANSITION_EFFECT_EMPTY_MENU: 'transition-effect-empty-menu',
    TRANSITION_EFFECT_FLASH_MENU: 'transition-effect-flash-menu',

    // 淡出淡入
    TRANSITION_EFFECT_FADE_MENU: 'transition-effect-fade-menu',
    TRANSITION_EFFECT_FADE_SMOOTH: 'transition-effect-fade-smooth',
    TRANSITION_EFFECT_FADE_BLACK: 'transition-effect-fade-black',

    // 推入
    TRANSITION_EFFECT_PUSH_MENU: 'transition-effect-push-menu',
    TRANSITION_EFFECT_PUSH_BOTTOM: 'transition-effect-push-bottom',
    TRANSITION_EFFECT_PUSH_LEFT: 'transition-effect-push-left',
    TRANSITION_EFFECT_PUSH_RIGHT: 'transition-effect-push-right',
    TRANSITION_EFFECT_PUSH_TOP: 'transition-effect-push-top',

    // 切换
    TRANSITION_EFFECT_SWITCH_MENU: 'transition-effect-switchKeyword-menu',
    TRANSITION_EFFECT_SWITCH_LEFT: 'transition-effect-switchKeyword-left',
    TRANSITION_EFFECT_SWITCH_RIGHT: 'transition-effect-switchKeyword-right',

    // 切入
    TRANSITION_EFFECT_CUT_MENU: 'transition-effect-cut-menu',
    TRANSITION_EFFECT_CUT_NONE: 'transition-effect-cut-none',
    TRANSITION_EFFECT_CUT_BLACK: 'transition-effect-cut-black',

    // 揭开
    TRANSITION_EFFECT_PULL_MENU: 'transition-effect-pull-menu',
    TRANSITION_EFFECT_PULL_RIGHT: 'transition-effect-pull-right',
    TRANSITION_EFFECT_PULL_TOP: 'transition-effect-pull-top',
    TRANSITION_EFFECT_PULL_LEFT: 'transition-effect-pull-left',
    TRANSITION_EFFECT_PULL_BOTTOM: 'transition-effect-pull-bottom',
    TRANSITION_EFFECT_PULL_RIGHT_UP: 'transition-effect-pull-right-up',
    TRANSITION_EFFECT_PULL_RIGHT_DOWN: 'transition-effect-pull-right-down',
    TRANSITION_EFFECT_PULL_LEFT_UP: 'transition-effect-pull-left-up',
    TRANSITION_EFFECT_PULL_LEFT_DOWN: 'transition-effect-pull-left-down',

    // 覆盖
    TRANSITION_EFFECT_COVER_MENU: 'transition-effect-cover-menu',
    TRANSITION_EFFECT_COVER_RIGHT: 'transition-effect-cover-right',
    TRANSITION_EFFECT_COVER_TOP: 'transition-effect-cover-top',
    TRANSITION_EFFECT_COVER_LEFT: 'transition-effect-cover-left',
    TRANSITION_EFFECT_COVER_BOTTOM: 'transition-effect-cover-bottom',
    TRANSITION_EFFECT_COVER_RIGHT_UP: 'transition-effect-cover-right-up',
    TRANSITION_EFFECT_COVER_RIGHT_DOWN: 'transition-effect-cover-right-down',
    TRANSITION_EFFECT_COVER_LEFT_DOWN: 'transition-effect-cover-left-down',
    TRANSITION_EFFECT_COVER_LEFT_UP: 'transition-effect-cover-left-up',

    // 缩放
    TRANSITION_EFFECT_WARP_MENU: 'transition-effect-warp-menu',
    TRANSITION_EFFECT_WARP_ENLARGE: 'transition-effect-warp-enlarge',
    TRANSITION_EFFECT_WARP_NARROW: 'transition-effect-warp-narrow',

    TRANSITION_EFFECT_NEWSFLASH: 'transition-effect-newsflash',

    // 翻转
    TRANSITION_EFFECT_FLIP_MENU: 'transition-effect-flip-menu',
    TRANSITION_EFFECT_FLIP_RIGHT: 'transition-effect-flip-right',
    TRANSITION_EFFECT_FLIP_LEFT: 'transition-effect-flip-left',

    // 库
    TRANSITION_EFFECT_GALLERY_MENU: 'transition-effect-gallery-menu',
    TRANSITION_EFFECT_GALLERY_RIGHT: 'transition-effect-gallery-right',
    TRANSITION_EFFECT_GALLERY_LEFT: 'transition-effect-gallery-left',

    // 立方体
    TRANSITION_EFFECT_PRISM_MENU: 'transition-effect-prism-menu',
    TRANSITION_EFFECT_PRISM_BOTTOM: 'transition-effect-prism-bottom',
    TRANSITION_EFFECT_PRISM_TOP: 'transition-effect-prism-top',
    TRANSITION_EFFECT_PRISM_LEFT: 'transition-effect-prism-left',
    TRANSITION_EFFECT_PRISM_RIGHT: 'transition-effect-prism-right',


    // 动画
    ANIM_PREVIEW: 'anim_preview',
    ANIM_BRUSH: 'anim_brush',
    ANIM_ENTR: 'anim_entr',
    ANIM_EMPH: 'anim_emph',
    ANIM_EXIT: 'anim_exit',
    ANIM_PANE: 'anim_pane',
    ANIM_START: 'anim_start',
    ANIM_TRIGGER: 'anim_trigger',
    ANIM_DELAY: 'anim_delay',
    ANIM_DURATION: 'anim_duration',
    ANIM_MENU_PREVIEW: 'anim_menu_preview',
    ANIM_AUTO_PREVIEW: 'anim_auto_preview',
    ANIM_CORNER_MARK: 'anim_corner_mark',
    CLICK_EFFECT: 'clickEffect',
    WITH_EFFECT: 'withEffect',
    AFTER_EFFECT: 'afterEffect',
    BATCH_HANDLE_ANIMATION: 'batch_handle_animation',

    // 移动端top menu
    AIDE: 'aide',
    ANONYMOUS_VIEW_M: 'anonymous_view_m',
    APPLY_AUTH: 'apply_auth',
    FILE_CACHE: 'file_cache',
    COLLECT: 'collect',
    CONVERT_TO_MULTI_DOC: 'convert_to_multi_doc',
    CONVERT_TO_PDF: 'convert_to_pdf',
    DUPLICATE: 'duplicate',
    EXPORT_TO_PC: 'export_to_pc',
    FILE_INFO: 'file_info',
    DRIVE_FILE_UPLOAD: 'drive_file_upload',
    MOVE_FILE: 'move_file',
    AUTH_SETTING: 'auth_setting',
    SCAN_HISTORY: 'scan_history',
    SHARE_AND_SEND: 'share_and_send',
    SYNC_ENT: 'sync_ent',
    TITLE_HIGHLIGHT: 'title_highlight',
    TRANSFER_FILE: 'transfer_file',
    TRANSFER_MUTI_EDIT: 'transfer_muti_edit',

    // 工具栏表格
    TABLE_STYLE_PANEL: 'table_style_panel',
    TABLE_TITLE_LINE: 'table_title_line',
    TABLE_FIRST_LINE: 'table_first_line',
    TABLE_TOTAL_LINE: 'table_total_line',
    TABLE_LAST_LINE: 'table_last_line',
    TABLE_EDGE_ROW: 'table_edge_row',
    TABLE_EDGE_COL: 'table_edge_col',
    TABLE_QUICK_SETTING: 'table_quick_setting',
    TABLE_CLEAR: 'table_clear',
    MERGE_CELL_TOOLBAR: 'merge_cell_toolbar',
    CANCEL_CELL_TOOLBAR: 'cancel_cell_toolbar',
    MERGE_CELL_TOOLBAR_PARENT: 'merge_cell_toolbar_parent',
    MERGE_CELL_TOOLBAR_TEXT: 'merge_cell_toolbar_text',
    MERGE_CELL_AND_SELECT: 'merge_cell_and_select',
    CANCEL_CELL_TOOLBAR_TEXT: 'cancel_cell_toolbar_text',
    BORDER_STYLE_TOOLBAR: 'border_style_toolbar',
    BORDER_WIDTH_TOOLBAR: 'border_width_toolbar',
    DELETE_TABLE_TOOLBAR: 'delete_table_toolbar',
    DELETE_TABLE_ALL_TOOLBAR: 'delete_table_toolbar',
    INSERT_TOP_TOOLBAR: 'insert_top_toolbar',
    INSERT_BOTTOM_TOOLBAR: 'insert_bottom_toolbar',
    INSERT_LEFT_TOOLBAR: 'insert_left_toolbar',
    INSERT_RIGHT_TOOLBAR: 'insert_right_toolbar',
    TABLE_SHARING_ROW: 'table_sharing_row',
    TABLE_SHARING_COL: 'table_sharing_col',
    TABLE_ROW_HEIGHT: 'table_row_height',
    TABLE_COL_WIDTH: 'table_col_width',
    TABLE_FONT_MARGIN: 'table_font_margin',
    TABLE_FONT_MARGIN_SMALL: 'table_font_margin_small',
    TABLE_FONT_MARGIN_NORMAL: 'table_font_margin_normal',
    TABLE_FONT_MARGIN_BIG: 'table_font_margin_big',
    TABLE_FONT_MARGIN_NONE: 'table_font_margin_none',
    TABLE_FONT_DIRECTION: 'table_font_direction',
    TABLE_ROW_HEIGHT_TOOLBAR: 'table_row_height_toolbar',
    TABLE_COL_WIDTH_TOOLBAR: 'table_col_width_toolbar',

    // 工具栏会员专享
    VIP_CENTER: 'vip_center',
    MORE_VIP_PRIVILEGES: 'more_vip_privileges',
    VIP_TEMPLATE: 'vip_template',
    // 工具栏图片
    PICTURE_CORRECTIONS: 'picture_corrections',
    PICTURE_TRANSPARENCY: 'picture_transparency',
    PICTURE_FAST_STYLE: 'picture_fast_style',
    PICTURE_HEIGHT: 'picture_height',
    PICTURE_WIDTH: 'picture_width',
    CROP_TO_SHAPE: 'crop_to_shape',
    ROTATE_RIGHT_90: 'rotate_right_90',
    ROTATE_LEFT_90: 'rotate_left_90',
    FLIP_VERTICAL: 'flip_vertical',
    FLIP_HORIZONTAL: 'flip_horizontal',

    // 工具栏形状
    SHAPE_FAST_STYLE: 'shape_fast_style',
    TEXT_FAST_STYLE: 'text_fast_style',
    FONT_BORDER_TOOLBAR: 'font_border_toolbar',
    FONT_EFFECT_TOOLBAR: 'font_effect_toolbar',
    FONT_SHADOW_TOOLBAR: 'font_shadow_toolbar',
    FONT_REFLECTION_TOOLBAR: 'font_reflection_toolbar',
    FONT_GLOW_TOOLBAR: 'font_glow_toolbar',

    CONVERT_TO_GROUP: 'convert_to_group',
    TEMPLATE_MALL: 'template_mall',
    // 批注
    COMMENT: 'comment',  // 批注
    SHOW_COMMENT: 'show-comment', // 查看批注
    INSERT_COMMENT: 'insert-comment', // 插入批注
    DELETE_COMMENT: 'delete-comment', // 删除批注
    DELETE_COMMENT_GROUP: 'delete-comment-group',   // 删除该组批注
    DELETE_PAGE_COMMENT: 'delete-page-comment',   // 删除当前页批注
    DELETE_ALL_COMMENT: 'delete-all-comment',   // 删除当前文档所有批注
    JUMP_TO_PREV_COMMENT: 'jump-to-prev-comment', // 上一条批注
    JUMP_TO_NEXT_COMMENT: 'jump-to-next-comment', // 下一条批注
    SHOW_COMMENT_ANCHOR: 'show-comment-anchor', // 显示批注标记
    SHOW_COMMENT_NOTIFY_FLAG: 'show-comment-notify-flag',    // 显示批注红点标记
    EXIT_MASTER_EDIT: 'exit-master-edit', // 退出母版编辑状态
    PERSONALIZATION: 'personalization', // 文档个性化
    // AI 写作
    AI_WRITE: 'ai-write',
    AI_WRITE_MOBILE: 'ai-write-mobile',
    // AI
    AI_REVIEW: 'ai_review', // ai审阅
    IMAGES_JOINT: 'images-joint', // 图片拼接
};
export type IActionType = typeof ActionType[keyof typeof ActionType];

export const InsertStateType = {
    NULL: 'null',
    TEXTBOX: 'text-box', // 文本框
    SHAPE: 'shape', // 图形
    CONNECTOR: 'connector', // 连接线
    ARBITRARYSHAPE: 'arbitrary-shape', // 任意形状
    FREECURVE: 'free-curve', // 自由曲线
    PLACEHOLDER: 'placeholder', // 占位符
} as const;

export const LastInsertButtonType = {
    CLICK_TOOL: 1,
    CLICK_MENU: 2,
};
